<template>
  <div class="rowtable">
    <div class="botn">
      <el-table
        :max-height="tableMaxHeight"
        :data="tableData"
        ref="multipleTable"
        class="listTable"
        :class="{'non-margin': nonMargin}"
        v-loading="loading"
        border
        :span-method="arraySpanMethod"
        @selection-change="handleSelectionChange"
        @select="handleSelect"
        @select-all="handleSelectAll"
        @header-dragend="()=>updateTable()"
        :show-summary="summary"
        :summary-method="summaryMethod"
        :header-cell-class-name="headerCellClassMethod"
        :cell-style="cellStyleFn"
      >
        <el-table-column v-if="selseflag" type="selection" :width="widthCon" />
        <el-table-column v-if="showIndex" label="序号" type="index" width="60" />
        <template v-for="(item, index) in colLists">
          <template v-if="!item.children  && !item.formSolt">
            <el-table-column
              :show-overflow-tooltip="true"
              :key="`col_${index}`"
              :label="item.label"
              :width="item.width"
              :min-width="item.minWidth"
              v-if="item.isTrue "
              :prop="item.prop"
              :align="item.align || 'center'"
              :fixed="item.rightFlag ? 'right' : (item.leftFlag ? 'left' : false)"
            >
              <template slot-scope="scope">
                <template v-if="item.solt">
                  <slot name="solts" :data="scope.row" :index="scope.$index"></slot>
                </template>
                <span
                  v-else
                  @click="item.clickflag ? itemClict(scope.row) : function () {}"
                >{{ item.formatter && item.formatter(scope.row) ? item.formatter(scope.row) : (scope.row[item.prop] || '-') }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-if="!item.children  && item.formSolt">
            <el-table-column
              :show-overflow-tooltip="true"
              :key="`col_${index}`"
              :label="item.label"
              :width="item.width"
              :min-width="item.minWidth"
              v-if="item.isTrue "
              :align="item.align || 'center'"
              :fixed="item.rightFlag ? 'right' : (item.leftFlag ? 'left' : false)"
            >
              <template slot-scope="scope">
                <template v-if="item.formSolt">
                  <slot :name="item.prop" :data="scope.row" :index="scope.$index" :item="item"></slot>
                </template>
                <span
                  v-else
                  @click="item.clickflag ? itemClict(scope.row) : function () {}"
                >{{ scope.row[item.prop] || '-' }}</span>
              </template>
            </el-table-column>
          </template>

          <!-- //二级表头 -->
          <template v-if="item.children">
            <el-table-column :label="item.label" :align="item.align || 'center'">
              <template v-for="d in item.children">
                <el-table-column
                  :show-overflow-tooltip="true"
                  :key="d.label"
                  :label="d.label"
                  :width="d.width"
                  :min-width="item.minWidth"
                  v-if="d.isTrue "
                  :prop="d.prop"
                  :align="d.align || 'center'"
                  :fixed="d.rightFlag ? 'right' : (d.leftFlag ? 'left' : false)"
                >
                  <template slot-scope="scope">
                    <template v-if="d.formSolt">
                      <slot :name="d.prop" :data="scope.row" :index="scope.$index" :item="d"></slot>
                    </template>
                    <span
                      v-else
                      @click="d.clickflag ? itemClict(d.row) : function () {}"
                    >{{ d.formatter && d.formatter(scope.row) ? d.formatter(scope.row) : (scope.row[d.prop] || '-') }}</span>
                    <!-- <span
                      v-else
                      @click="d.clickflag ? itemClict(d.row) : function () {}"
                    >{{ scope.row[d.prop] || '-' }}</span>-->
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table>
    </div>

    <Pagination
      v-if="paginationFlag"
      class="pagination"
      :total="total"
      :page.sync="queryParams.pageNo"
      :limit.sync="queryParams.pageSize"
      @pagination="pageChange"
      :current-page="currentPage"
      layout="total,sizes,prev, pager, next"
    />
  </div>
</template>

<script>
// import Mixins from '@/mixins'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  name: 'tablePublic',
  // mixins: [Mixins],
  data() {
    return {
      getRowKeys: '',
      currentPage: 1,
      queryParams: {
        pageSize: 10,
        pageNo: 1,
      },
    }
  },
  props: {
    tableHeight: {
      type: String,
      default: '642',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    //表单内table带输入只校验Null的可传true
    nonMargin: {
      type: Boolean,
      default: false,
    },
    paginationFlag: {
      type: Boolean,
      default: true,
    },
    summary: {
      type: Boolean,
      default: false,
    },
    summaryMethod: {
      type: Function,
      default: null,
    },
    headerCellClassMethod: {
      type: Function,
      default: null,
    },
    arraySpanMethod: {
      type: Function,
      default: null,
    },
    widthCon: {
      type: String,
      default: '50px',
    },
    operation: {
      type: Object,
      default: () => {
        return {
          rowflag: false,
          seeFlag: false,
          modifyFlag: false,
          submitFlag: false,
          approvalFlag: false,
          completeFlag: false,
          situationFlag: false,
          seeFion: false,
        } //操作按钮的展示显示标识
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    changeMechNum: {
      type: Boolean,
      default: false,
    },
    selseflag: {
      type: Boolean,
      default: false,
    },
    //表头数组样例
    colLists: {
      type: Array,
      default: () => [
        {
          prop: 'name',
          label: '职责',
          isTrue: true,
          width: 100,
          colorflag: true, //文字有自定义颜色
        },
        {
          prop: 'type',
          label: '合同类型',
          isTrue: true,
        },
      ],
    },
    //表格数据样例
    tableData: {
      type: Array,
      default: () => [
        { name: '岗位', type: '前端开发' },
        { name: '岗111位', type: '材料采购合同' },
      ],
    },
    showIndex: {
      type: Boolean,
      default: () => true,
    },
    pageParams: {
      type: Object,
      default: () => {
        return {
          pageNo: 1,
          pageSize: 10,
        }
      },
    },
    height: {
      type: [String, Number],
      default: 'auto',
    },
    computedHeight: {
      type: Boolean,
      default: false,
    },
    cellStyle: {
      type: [Object, Function],
      default: () => {},
    },
  },
  computed:{
    tableMaxHeight(){
      return this.summary ? '700' : this.tableHeight
    }
  },
  watch: {
    // height(newVal){
    //   this.height = newVal
    // },
    ['TABLE_HEIGHT'](newVal) {
      this.height = newVal
    },
    ['tableData']: {
      deep: true,
      handler(newVal) {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
        if (this.computedHeight == true) {
          console.log('数组长度已经改变了', newVal.length)
          this.estimateTableHeight(newVal.length)
        }
      },
    },
    pageParams: {
      deep: true,
      handler(newVal) {
        this.queryParams.pageNo = newVal.pageNo
        this.queryParams.pageSize = newVal.pageSize
        this.currentPage = newVal.pageNo
      },
    },
  },
  created() {},
  // 表格样式重置
  updated() {
    this.updateTable()
  },
  methods: {
    updateTable() {
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout()
      })
    },
    itemClict(row) {
      this.$emit('itemClict', row)
    },
    itemClick(row) {
      this.$emit('itemClick', row)
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    },
    handleSelect(selection, row) {
      this.$emit('handleSelect', selection, row)
    },
    handleSelectAll(selection) {
      this.$emit('handleSelectAll', selection)
    },
    handleOpenRowSelection(row) {
      this.$refs.multipleTable.toggleRowSelection(row, true)
    },
    handleCancelRowSelection(row) {
      this.$refs.multipleTable.toggleRowSelection(row, false)
    },
    // arraySpanMethod() {
    //   this.$emit('arraySpanMethod')
    // },

    //查看图标
    look() {},
    customFun(index, row) {
      this.$emit('customFun', index, row)
    },
    //自定义颜色
    colorChoice(row, item) {
      console.log('-------------row-----------------------')
      if (row.colorflag) {
        console.log(row.props.colorChoice(item))
        return row.props.colorChoice(item)
      }
    },
    //点击分页
    pageChange(val) {
      console.log('变化分页', val)
      let data = {
        pageSize: val.limit,
        pageNo: val.page,
      }
      this.$emit('pageChange', data)
    },
    //查看
    handleSee(index, row) {
      this.$emit('handleSee', index, row)
    },
    //修改
    handleModify(index, row) {
      this.$emit('handleModify', index, row)
    },
    //提交
    handleSubmit(index, row) {
      this.$emit('handleSubmit', index, row)
    },
    //审批流
    handleApproval(index, row) {
      this.$emit('handleApproval', index, row)
    },
    //完成
    handleComplete(index, row) {
      this.$emit('handleComplete', index, row)
    },
    //修改执行情况
    handleSituation(index, row) {
      this.$emit('handleSituation', index, row)
    },
    cellStyleFn(row) {
      // textAlign: 'center'
      if (row.column.label == '单号' || (this.changeMechNum && row.column.label == '标号')) {
        return { color: '#2f4cdd', cursor: 'pointer' }
      } else {
        let cellStyle = {}
        if (this.cellStyle && typeof this.cellStyle == 'function') {
          cellStyle = this.cellStyle(row) || {}
        } else if (typeof this.cellStyle == 'object') {
          cellStyle = this.cellStyle || {}
        }
        return { color: '#000000', ...cellStyle, }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.multipleTable.doLayout()
    })
  },
}
</script>

<style scoped lang="less">
@import '~@/assets/variables.less';

.el-icon-setting {
  cursor: pointer;
}

.rowtable {
  .colortext {
    color: #2f4cdd;
    cursor: pointer;
    text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
    white-space: nowrap; /*让文字不换行*/
    overflow: hidden; /*超出要隐藏*/
  }

  .spacing {
    margin-right: 20px;
    color: #2f4cdd;
    display: inline;
    cursor: pointer;
  }
  ::v-deep {
    .el-table__cell {
      border-bottom: 1px solid #d7d7d7;
    }
    .non-margin {
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__content {
          margin: 0 !important;
          .el-select {
            width: 100%;
          }
        }
      }
      .el-form-item.is-error .el-input .el-input__inner::placeholder {
        color: #f56c6c;
      }
    }
    .el-pagination .el-pager li {
      color: #000;
    }
    .el-table__fixed-body-wrapper {
      height: 100% !important;
    }
    .listTable {
      border: 2px solid #ebeffa;
      // border-top-right-radius: 16px;
      // border-top-left-radius: 16px;
      // border-bottom-width: 1px;
      border-radius: @table-radius-size;

      &::before {
        display: none;
      }

      &::after {
        display: none;
      }
    }

    table th.star div::before {
      content: '*';
      color: #ff4949;
      margin-right: 4px;
    }

    .el-table__footer-wrapper {
      margin-top: 0px;
      td.el-table__cell {
        background: #fff;
        color: #282c38;
      }
    }
    .el-table__cell {
      border-right: none;
    }
    .el-table__header-wrapper {
      border-radius: @table-radius-size @table-radius-size 0px 0px;
    }
    .el-table th.el-table__cell {
      background: #ece4ce;
      color: #282c38;
      font-size: 14px;
      .cell {
        border-right: 1px solid #cfcff4;
      }
    }
    // .el-table .el-table__cell {
    //   text-align: left;
    // }
    // 分页
    .pagination {
      //padding-right: 60px;
      height: 44px;
      // position: fixed;
      right: 15px;
      bottom: 20px;
      .el-pagination {
        display: -moz-box;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flexbox;
        display: flex;

        -webkit-box-pack: right;
        -ms-justify-content: right;
        -moz-justify-content: right;
        -o-justify-content: right;
        -webkit-justify-content: right;
        justify-content: right;

        -webkit-box-align: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        -webkit-align-items: center;
        align-items: center;

        height: 100%;
        padding: 0;
        .el-pagination__sizes .el-select .el-input__inner {
          line-height: normal;
        }
      }

      // 上一页
      .btn-prev,
      .btn-next {
        width: 100px;
        height: 100%;
        border-radius: @btn-radius-size;

        .el-icon {
          text-align: center;
          margin: auto;
          font-size: 14px;

          &::before {
            width: 3px;
            height: 10px;
            font-size: 16px;
            content: '<';
            color: #d3d6e4;
          }

          &::after {
            content: '上一页';
            color: #ffffff;
            margin-left: 5px;
          }
        }
      }

      .btn-prev {
        background-color: #b7b7b7;

        .el-icon {
          &::before {
            width: 3px;
            height: 10px;
            font-size: 16px;
            content: '<';
            color: #d3d6e4;
          }

          &::after {
            content: '上一页';
            color: #ffffff;
            margin-left: 5px;
          }
        }
      }

      .btn-next {
        background-color: @theme-color;

        .el-icon {
          &::after {
            width: 3px;
            height: 10px;
            font-size: 16px;
            content: '>';
            color: #d3d6e4;
          }

          &::before {
            content: '下一页';
            color: #ffffff;
            margin-right: 5px;
            font-size: 14px;
          }
        }
      }

      .el-pager {
        display: flex;
        align-items: center;
        height: 100%;
        background-color: #e3e4eb;
        border-radius: @btn-radius-size;

        .number {
          width: 40px;
          height: 35px;
          line-height: 35px;
          font-size: 14px;
          background-color: #e3e4eb;
        }

        .active {
          background-color: #ffffffeb !important;
          border-radius: @btn-radius-size;
          color: black !important;
        }
      }
    }
  }
}
/* 存在固定列时，合计行位置修改开始 */
.el-table /deep/ .el-table__fixed-footer-wrapper {
  position: initial;
}
/* 默认有1px去掉样式影响 */
.el-table /deep/ .el-table__fixed::before {
  height: 0;
}
</style>
